import script from "./register.vue?vue&type=script&setup=true&name=Register&lang=js"
export * from "./register.vue?vue&type=script&setup=true&name=Register&lang=js"

import "./register.vue?vue&type=style&index=0&id=2c58e1ee&scoped=true&lang=css"
import "./register.vue?vue&type=style&index=1&id=2c58e1ee&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c58e1ee"]])

export default __exports__